<template>
  <div class="home">
    <div class="home-nav">
      <mt-swipe :auto="4000">
        <mt-swipe-item class="slid4" @click.native.capture= "go_Liucheng1()">
          <img style="width: 100%;height: 150px" src="/static/img/liucheng3.gif" alt="">
        </mt-swipe-item>
        <mt-swipe-item class="slid1" @click.native.capture= "goInvite(1)">
          <img style="width: 100%;height: 150px" src="https://mtcarousel.obs.cn-north-4.myhuaweicloud.com/2476f849-7ae6-4ca8-a65d-56d62d8b6c8a.jpg" alt="">
        </mt-swipe-item>
        <mt-swipe-item class="slid2" @click.native.capture= "goInvite(2)">
          <img style="width: 100%;height: 150px" src="https://mtcarousel.obs.cn-north-4.myhuaweicloud.com/c216de6e-dcbb-4aaa-b9d6-1e5edfbffbd1.jpg" alt="">
        </mt-swipe-item>
        <mt-swipe-item class="slid3">
          <img style="width: 100%;height: 150px" src="https://mtcarousel.obs.cn-north-4.myhuaweicloud.com/40cf25c5-1a7f-493b-9e93-e299fda70f83.jpg" alt="">
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="home-caozuo">
      <div class="cz-item" @click="agentMyXiaXian">
        <div class="item-icon2">
          <img src="../assets/img/a_xia_xian2.png" alt="我的推荐"/>
        </div>
      </div>
      <div class="cz-item" @click="agentMyOrder">
        <div class="item-icon2">
          <img src="../assets/img/a_my_order2.png" alt="我的订单"/>
        </div>
        <div class="num-mark" v-if="orderNum != 0">{{orderNum}}</div>
      </div>
      <div class="cz-item" @click="agentShipMagage">
        <div class="item-icon2">
          <img src="../assets/img/a_huo_manage2.png" alt="审核用户"/>
        </div>
        <div class="num-mark" v-if="auditNum != 0">{{auditNum}}</div>
      </div>
      <div class="cz-item" @click="agentMyXiaXian2">
        <div class="item-icon2">
          <img src="../assets/img/a_huo_manage3.png" alt="销售管理"/>
        </div>
      </div>
    </div>
    <!-- <div class="home-jieshao">
      <div class="jieshao1">
        <a href="https://mp.weixin.qq.com/mp/video?__biz=Mzg5NDExMzYwNg==&mid=100000030&sn=f78a50f2046b3b626db9e6120cfae7d8&vid=wxv_767165957138776064&idx=1&vidsn=135bcb5d5c3b43efae0fb418af03a2f3&fromid=1&scene=18&xtrack=1&version=62060739&ascene=1&session_us=gh_c838f10ece1e&lang=zh_CN&devicetype=Windows+10&winzoom=1"><img src="/static/img/product_explain.gif" alt="产品介绍"></a>
      </div>
      <div class="jieshao1" @click="go_Liucheng1">
        <img src="/static/img/liucheng.gif" alt="流程介绍">
      </div>
    </div> -->
    <div class="home-guanzhu" v-if="QRcode">
      <h4>欢迎加入天梯代理人团队</h4>
      <img src="../assets/img/ttkhjlr_wxcode.jpg" alt="公众号二维码">
      <div class="home-text">长按上方二维码,弹出识别二维码,关注 <a>天梯客户经理人</a> 公众号</div>
    </div>
    <div class="home-liucheng">
      <img src="/static/img/fw_phone.gif" alt="服务电话">
    </div>
    <div class="home-info">
      <div class='info-title'>
        <img src='/static/img/notify_info.png'/>
        <span class="color666"> 最新通知</span>
      </div>
      <div class='info-content' v-if="notifyList.length>0">
        <div class='content' v-for="(item) in notifyList" :key="item.ID" @click="go_detailInfo(item)">
          <div class="content-left color666">
            <span class='me_inLisOm'>{{item.Content}}</span>
            <p style="margin-top: 10px;"><span>{{item.TeacherName}}</span><span style="padding-left: 10px;"><img style="width: 15px;vertical-align: text-top" src='/static/img/time1.png'/> {{item.datas}}</span></p>
          </div>
          <div>

          </div>
          <!-- <div class="content-img">
           <img src='/static/img/me_userLisO4.png' class='me_inLisOr'>
          </div> -->
        </div>
      </div>
      <div v-if="notifyList.length == 0" style='text-align: center;margin-top: 40px'>
        <span class='me_inLisOm' style="color: #666;font-size: 14px;">暂无消息</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      requestUrl: 'https%3a%2f%2fagent.product.52bkb.com%2f%23%2f',
      watchData: 0,
      auditNum: 0,
      orderNum: 0,
      QRcode: false,
      notifyList: []
    }
  },
  watch: {
    'watchData': function() {
      let _this = this;
      if(_this.abp.UserInfos.userBearer) {
        const auditBackApi = new Promise((resolve, reject) => {
          let reqData = {
            State: [0],
            PageIndex: 1,
            PageSize: 100
          }
          _this.abp.api.AgentConfirmRgsList(reqData)
            .then((res)=> {
                resolve();
                if(res.status == 200) {
                    if(res.data.IsSuccess) {
                        _this.auditNum = res.data.Data.length;
                    }
                }
            })
            .catch((error)=>{
                reject();
                _this.$indicator.close();
                try {
                  switch(error.status) {
                    case 401:
                    _this.abp.api.reqSuccess(_this,'您没有权限！')
                  }
                } catch (txt) {
                  console.log(txt);
                }
            })
        })
        auditBackApi
          .then((res) => {
            let reqData2 = {
              State: [2],
              PageIndex: 1,
              PageSize: 100
            }
            _this.abp.api.OutLogListByState(reqData2)
              .then((res)=> {
                _this.$indicator.close();
                if(res.status == 200) {
                  if(res.data.IsSuccess) {
                    _this.orderNum = res.data.Data.SaleLog.length;
                  }else{
                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                  }
                }
              })
              .catch((error)=>{
                _this.$indicator.close();
                try {
                  switch(error.status) {
                      case 401:
                      _this.abp.api.reqSuccess(_this,'您没有权限！')
                  }
                } catch (txt) {
                  console.log(txt);
                }
              })
          })
        _this.abp.api.TeacherNeedsList()
          .then((res)=>{
              if(res.status == 200) {
                  _this.$indicator.close();
                  if(res.data.IsSuccess) {
                      _this.notifyList = res.data.Data.NeedList;
                      _this.notifyList.forEach(element => {
                         element.datas = element.CreateDate.replace("T"," ");
                      });
                  }else{
                      _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                  }
              }
          })
          .catch((error)=>{
              _this.$indicator.close();
              try {
                  switch(error.status) {
                      case 401:
                      _this.abp.api.reqSuccess(_this,'您没有权限！')
                  }
              } catch (txt) {
                  console.log(txt);
              }
          })
        }
    }
  },
  methods: {
    // 出货管理
    agentShipMagage() {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
        this.$router.push({
          path: '/agent/mouse'
        })
      }else{
        _this.$messagebox({
            title: '温馨提示',
            message: '请先关注“天梯客户经理人”公众号才可以操作',
            showCancelButton: false,
            confirmButtonText:"确定"
        }).then(action => {
            
        })
      }
    },
    // 我的订单
    agentMyOrder() {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
        this.$router.push({
          path: '/order/myorder'
        })
      }else{
        _this.$messagebox({
            title: '温馨提示',
            message: '请先关注“天梯客户经理人”公众号才可以操作',
            showCancelButton: false,
            confirmButtonText:"确定"
        }).then(action => {
            
        })
      }
    },
    // 我的下线
    agentMyXiaXian() {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
        this.$router.push({
          path: '/agent/xiaxianlist'
        })
      }else{
        _this.$messagebox({
            title: '温馨提示',
            message: '请先关注“天梯客户经理人”公众号才可以操作',
            showCancelButton: false,
            confirmButtonText:"确定"
        }).then(action => {
            
        })
      }
    },
    // 销售管理
    agentMyXiaXian2 () {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
        this.$router.push({
          path: '/agent/outinfo'
        })
      }else{
        _this.$messagebox({
            title: '温馨提示',
            message: '请先关注“天梯客户经理人”公众号才可以操作',
            showCancelButton: false,
            confirmButtonText:"确定"
        }).then(action => {
            
        })
      }
    },
    // 用户申请设备
    agentApplyMouse () {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
        this.$router.push({
          path: '/agent/applymouse'
        })
      }else{
        _this.$messagebox({
            title: '温馨提示',
            message: '请先关注“天梯客户经理人”公众号才可以操作',
            showCancelButton: false,
            confirmButtonText:"确定"
        }).then(action => {
            
        })
      }
    },
    // 邀请
    goInvite(e) {
      let _this = this;
      if(_this.abp.UserInfos.userGuanZhu) {
          if(e == 1) {
              this.$router.push({
                  path: '/userinfo/invitefriends'
              })
          }else if(e == 2){
              this.$router.push({
                  path: '/userinfo/inviteagent'
              })
          }
      }else{
          _this.$messagebox({
              title: '温馨提示',
              message: '请先关注“天梯客户经理人”公众号才可以操作',
              showCancelButton: false,
              confirmButtonText:"确定"
          }).then(action => {

          })
      }
    },
    // 流程1
    go_Liucheng1() {
      this.$router.push({
        path: '/message/liucheng1'
      })
    },
    // 进入消息详情页
    go_detailInfo(e) {
        var data=JSON.parse(e.Data);
        this.$router.push({
            name: 'agentApplymouse',
            params: {
                notifyID: e.NotifyID,
                content:e.Content,
                SchoolName:data.SchoolName,
                TeacherName:e.TeacherName,
                TeacherPhone:e.TeacherPhone,
                IsFeedback:0
            }
        })
    }
  },
  mounted() {
    let _this = this,
      reg = new RegExp('(^|&)code=([^&]*)(&|$)');
    _this.requestUrl = _this.abp.api.Hosts;
    if(_this.abp.UserInfos.userBearer) {
      _this.watchData = (_this.watchData + 1);
      if(_this.abp.UserInfos.userGuanZhu) {
        _this.QRcode = false;
      }else {
        _this.QRcode = true;
      }
      return;
    }
    let r = window.location.search.substr(1).match(reg);
    debugger
    if(r != null) {
      _this.$indicator.open('加载中...');
      _this.abp.api.AgentSignInWXPublic({ Code: r[2] })
        .then((res) => {
          if(res.status == 200) {
            if(res.data.IsSuccess) {
              _this.$indicator.close();
                sessionStorage.setItem('AuthorizationBearer',res.data.Data.Token);
                sessionStorage.setItem('UserInfo',_this.abp.f_Base64.encode(JSON.stringify(res.data.Data.Agent)));
                _this.abp.UserInfos.userInfo = res.data.Data.Agent;
                _this.abp.UserInfos.userBearer = res.data.Data.Token;
                _this.abp.UserInfos.userGuanZhu = res.data.Data.Subscribe == 1 ? true : false;
                _this.abp.UserInfos.userIsBind = res.data.Data.IsBind;
                localStorage.setItem('Subscribe',res.data.Data.Subscribe);
                sessionStorage.setItem('userIsBind',res.data.Data.IsBind);
                if(_this.abp.UserInfos.userGuanZhu) {
                  _this.QRcode = false;
                }
                _this.watchData = 1;
            }else{
                _this.$indicator.close();
                _this.abp.UserInfos.userBearer = null;
                try {
                  _this.abp.UserInfos.userGuanZhu = res.data.Data.Subscribe == 1 ? true : false;
                  localStorage.setItem('Subscribe',res.data.Data.Subscribe);
                  if(_this.abp.UserInfos.userGuanZhu) {
                    _this.QRcode = false;
                  }
                } catch (e) {
                  _this.abp.UserInfos.userGuanZhu = false;
                }
                if (res.data.OutputMessage == '用户微信信息验证错误') {
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx053841ab5ee642f5&redirect_uri='+_this.requestUrl+'%23%2fhome&response_type=code&scope=snsapi_base#wechat_redirect'
                }
            }
          }else{
            _this.$indicator.close();
          }
        })
        .catch((error)=>{
            _this.$indicator.close();
            try {
                switch(error.status) {
                    case 401:
                    _this.abp.api.reqSuccess(_this,'您没有权限！')
                }
            } catch (txt) {
                console.log(txt);
            }
        })
    }else{
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fhome&response_type=code&scope=snsapi_base#wechat_redirect'
    }
  }
}
</script>

<style lang="css" scoped>
  .home-nav {
      height: 150px;
  }
  .home-nav .slid1,
  .home-nav .slid2,
  .home-nav .slid3,
  .home-nav .slid4 {
      background-color: #fff;
      text-align: center;
      color: #fff;
      font-size: 26px;
  }
  .home-guanzhu {
    text-align: center;
  }
  .home-caozuo {
    border: none;
    display: flex;
    margin-top: 5px;
    background-color: #fff;
  }
  .home-caozuo > .cz-item {
    flex: 1;
    margin: 5px 0;
    cursor: pointer;
    text-align: center;
    position: relative;
  }
  .home-caozuo > .cz-item > .item-icon {
    width: 40px;
    height: 40px;
    margin: 0 auto 5px;
  }
  .home-caozuo > .cz-item > .item-icon2 {
    /* width: 92px;
    height: 80px; */
    margin: auto;
  }
  .home-caozuo > .cz-item > .item-icon2 >* {
    width: 100%;
    height: 100%;
  }
  .home-caozuo > .cz-item > .item-icon >* {
    width: 100%;
    height: 100%;
  }
  .home-caozuo > .cz-item > .num-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: red;
    color: #fff;
    font-size: 12px;
    position: absolute;
    right: 20px;
    top: 0px;
  }
  .home-caozuo > .cz-item > .item-title,
  .home > .home-guanzhu > .home-text  {
    font-size: 14px;
  }
  .home > .home-jieshao {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    background-color: #ddd;
  }
  .home > .home-jieshao > .jieshao1 {
    flex: 1;
  }
  .home > .home-jieshao > .jieshao1 * {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .home > .home-guanzhu > .home-text a {
    color: #12b7f5;
  }
  .home > .home-guanzhu > img {
    width: 150px;
    height: 150px
  }
  .home  > .home-guanzhu >.guanzhu {
    display: block;
    width: 180px;
    height: 30px;
    line-height: 30px;
    background-color: #0dbc79;
    text-decoration: none;
    border-radius: 15px;
    color: #fff;
    margin: auto;
    margin-top: 15px;
  }
  .home .home-iphone {
    display: flex;
    margin: 40px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
  }
  .home .home-iphone>span:last-child {
    color: blue;
    text-decoration: underline;
  }
  .home .home-liucheng {
    padding: 5px;
    display: flex;
    height: 100px;
    position: relative;
  }
  .home .home-liucheng img {
    width: 100%;
    height: 100%;
  }
  .home > .home-info > .info-title {
    font-size: 16px;
    color:#333;
    padding: 10px 5px;
    font-weight: bold;
    position: relative
  }
  .home > .home-info > .info-title >img {
    width: 20px;
    height: 20px;
  }
  .home > .home-info > .info-title,
  .home > .home-info > .info-content > .content {
    display: flex;
    align-items: center;
  }
  .home > .home-info > .info-content > .content {
    border-bottom: 1px solid #eee;
    padding: 5px 10px 0px;
  }
  .home > .home-info > .info-content .content-left {
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }
  .home > .home-info > .info-content .content-img {
    width: 30px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home > .home-info > .info-content .content-img >* {
    height: 14px;
  }
  .color666{
    color: #666;
    margin-left: 5px;
  }
</style>
